export default __webpack_public_path__ + "static/media/singlife_square.29a28427.svg";